import React, { useState } from 'react';

import PolicyForm from '../../../PolicyPlans/Form';
import PageTitleNew from '../../../ui/PageTitleNew';

import { usePolicyPlanTemplateContext } from '../../../../contexts/PolicyPlanTemplateContext';

export default function Create({ onSuccessCreate, onCancel }) {
  const { dispatch, actions, state } = usePolicyPlanTemplateContext();

  const onSave = (values, onError) => {
    actions.create(
      dispatch,
      values,
      () => {
        onSuccessCreate();
        actions.load(dispatch);
      },
      (errors) => {
        onError(errors);
      },
    );
  };

  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Create a Plan Template" />

      <PolicyForm onSubmit={onSave} onCancel={onCancelHandler} />
    </div>
  );
}
